import { EName as EPreciseFilterValues } from '../../repositories/price-estimator/entities/filter/FilterOptionSchema';
import {
  EName as EPreciseFilterNames,
  EType as EPreciseFilterTypes,
} from '../../repositories/price-estimator/entities/filter/FilterSchema';

export interface IPreciseFiltersState {
  data: {
    isFetching: boolean;
    isError: boolean;
    sale: IPreciseFiltersData | null;
    rent: IPreciseFiltersData | null;
  };
  ui: TPreciseFiltersState;
}

export interface IPreciseFiltersData {
  mainFilter?: IPreciseFilter;
  filters: IPreciseFilter[];
}

export interface IPreciseFilter {
  displayName: string;
  name: EPreciseFilterNames;
  type: EPreciseFilterTypes;
  options: IFilterOption[];
  disabled?: boolean;
}

export enum EExtendsOptions {
  Reset = 'reset',
}

export interface IFilterOption {
  displayName: string;
  helpText?: string | null;
  name: EPreciseFilterValues;
  iconUrl?: string | null;
}

export type TPreciseFiltersState = { [K in EPreciseFilterNames]?: EPreciseFilterValues[] };

export interface IGetPreciseFiltersNextStateParams {
  filterValue: EPreciseFilterValues;
  filterName: EPreciseFilterNames;
  filterType: EPreciseFilterTypes;
  prevState: TPreciseFiltersState;
}

export { EPreciseFilterValues, EPreciseFilterNames, EPreciseFilterTypes };
